// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_State from "../Control.Monad.State/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Spelled from "../Data.Pitches.Spelled/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as ProtoVoices_Folding from "../ProtoVoices.Folding/index.js";
import * as ProtoVoices_Model from "../ProtoVoices.Model/index.js";
var bindStateT = /* #__PURE__ */ Control_Monad_State_Trans.bindStateT(Data_Either.monadEither);
var bind = /* #__PURE__ */ Control_Bind.bind(bindStateT);
var monadStateStateT = /* #__PURE__ */ Control_Monad_State_Trans.monadStateStateT(Data_Either.monadEither);
var get = /* #__PURE__ */ Control_Monad_State_Class.get(monadStateStateT);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(bindStateT);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(monadStateStateT);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_State_Trans.applicativeStateT(Data_Either.monadEither));
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_State_Trans.monadTransStateT)(Data_Either.monadEither);
var map = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_State_Trans.functorStateT(Data_Either.functorEither));
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var evalStateT = /* #__PURE__ */ Control_Monad_State_Trans.evalStateT(Data_Either.functorEither);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var ordRecord = /* #__PURE__ */ Data_Ord.ordRecord();
var ordRecordCons = /* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)();
var ordStartStop = /* #__PURE__ */ ProtoVoices_Model.ordStartStop(/* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons({
    reflectSymbol: function () {
        return "pitch";
    }
})(/* #__PURE__ */ Data_Pitches_Class.ordPitch(Data_Pitches_Spelled.ordSInterval)))()({
    reflectSymbol: function () {
        return "id";
    }
})(Data_Ord.ordString)));
var ordRecord1 = /* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons({
    reflectSymbol: function () {
        return "right";
    }
})(ordStartStop))()({
    reflectSymbol: function () {
        return "left";
    }
})(ordStartStop));
var catMaybes = /* #__PURE__ */ Data_Set.catMaybes(ordRecord1);
var map2 = /* #__PURE__ */ Data_Set.map(/* #__PURE__ */ Data_Maybe.ordMaybe(ordRecord1));
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var discard2 = /* #__PURE__ */ discard(/* #__PURE__ */ Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity));
var modify_1 = /* #__PURE__ */ Control_Monad_State_Class.modify_(/* #__PURE__ */ Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity));
var pure2 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity));
var map4 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var pruneReduction = function (nsteps) {
    return function (red) {
        var split = function (v) {
            return function (seg) {
                return function (rest) {
                    return bind(get)(function (n) {
                        var $94 = n <= 0;
                        if ($94) {
                            return go(new Data_List_Types.Cons({
                                rslice: seg.rslice,
                                trans: seg.trans,
                                op: ProtoVoices_Model.Freeze.value
                            }, rest));
                        };
                        return discard1(modify_(function (v1) {
                            return v1 - 1 | 0;
                        }))(function () {
                            return bind(go(new Data_List_Types.Cons(v.childl, new Data_List_Types.Cons(ProtoVoices_Model.attachSegment(v.childr)(seg.rslice), rest))))(function (res) {
                                if (res instanceof Data_List_Types.Cons && res.value1 instanceof Data_List_Types.Cons) {
                                    return pure(new Data_List_Types.Cons({
                                        rslice: seg.rslice,
                                        trans: seg.trans,
                                        op: new ProtoVoices_Model.Split({
                                            childl: res.value0,
                                            childr: ProtoVoices_Model.detachSegment(res.value1.value0)
                                        })
                                    }, res.value1.value1));
                                };
                                return lift(new Data_Either.Left("invalid result of split"));
                            });
                        });
                    });
                };
            };
        };
        var go = function (v) {
            if (v instanceof Data_List_Types.Nil) {
                return pure(Data_List_Types.Nil.value);
            };
            if (v instanceof Data_List_Types.Cons && v.value1 instanceof Data_List_Types.Nil) {
                if (v.value0.op instanceof ProtoVoices_Model.Freeze) {
                    return pure(new Data_List_Types.Cons(v.value0, Data_List_Types.Nil.value));
                };
                if (v.value0.op instanceof ProtoVoices_Model.Split) {
                    return split(v.value0.op.value0)(v.value0)(Data_List_Types.Nil.value);
                };
                if (v.value0.op instanceof ProtoVoices_Model.Hori) {
                    return pure(new Data_List_Types.Cons(v.value0, Data_List_Types.Nil.value));
                };
                throw new Error("Failed pattern match at Pruning (line 27, column 23 - line 30, column 34): " + [ v.value0.op.constructor.name ]);
            };
            if (v instanceof Data_List_Types.Cons && v.value1 instanceof Data_List_Types.Cons) {
                if (v.value0.op instanceof ProtoVoices_Model.Freeze) {
                    return map(Data_List_Types.Cons.create(v.value0))(go(v.value1));
                };
                if (v.value0.op instanceof ProtoVoices_Model.Split) {
                    return split(v.value0.op.value0)(v.value0)(v.value1);
                };
                if (v.value0.op instanceof ProtoVoices_Model.Hori) {
                    if (v.value1.value0.op instanceof ProtoVoices_Model.Split) {
                        return bind(get)(function (n) {
                            var $111 = n <= 0;
                            if ($111) {
                                return map(map1(Data_List_Types.Cons.create({
                                    rslice: v.value0.rslice,
                                    trans: v.value0.trans,
                                    op: ProtoVoices_Model.Freeze.value
                                }))(Data_List_Types.Cons.create({
                                    rslice: v.value1.value0.rslice,
                                    trans: v.value1.value0.trans,
                                    op: ProtoVoices_Model.Freeze.value
                                })))(go(v.value1.value1));
                            };
                            return discard1(modify_(function (v1) {
                                return v1 - 1 | 0;
                            }))(function () {
                                return bind(go(new Data_List_Types.Cons(v.value0, new Data_List_Types.Cons(v.value1.value0.op.value0.childl, new Data_List_Types.Cons(ProtoVoices_Model.attachSegment(v.value1.value0.op.value0.childr)(v.value1.value0.rslice), v.value1.value1)))))(function (res) {
                                    if (res instanceof Data_List_Types.Cons && (res.value1 instanceof Data_List_Types.Cons && res.value1.value1 instanceof Data_List_Types.Cons)) {
                                        return pure(new Data_List_Types.Cons(res.value0, new Data_List_Types.Cons({
                                            rslice: v.value1.value0.rslice,
                                            trans: v.value1.value0.trans,
                                            op: new ProtoVoices_Model.Split({
                                                childl: res.value1.value0,
                                                childr: ProtoVoices_Model.detachSegment(res.value1.value1.value0)
                                            })
                                        }, res.value1.value1.value1)));
                                    };
                                    return lift(new Data_Either.Left("invalid result of right split"));
                                });
                            });
                        });
                    };
                    return bind(get)(function (n) {
                        var $120 = n <= 0;
                        if ($120) {
                            return map(Data_List_Types.Cons.create({
                                rslice: v.value0.rslice,
                                trans: v.value0.trans,
                                op: ProtoVoices_Model.Freeze.value
                            }))(go(v.value1));
                        };
                        return discard1(modify_(function (v1) {
                            return v1 - 1 | 0;
                        }))(function () {
                            return bind(go(new Data_List_Types.Cons(v.value0.op.value0.childl, new Data_List_Types.Cons(v.value0.op.value0.childm, new Data_List_Types.Cons(ProtoVoices_Model.attachSegment(v.value0.op.value0.childr)(v.value1.value0.rslice), v.value1.value1)))))(function (res) {
                                if (res instanceof Data_List_Types.Cons && (res.value1 instanceof Data_List_Types.Cons && res.value1.value1 instanceof Data_List_Types.Cons)) {
                                    return pure(new Data_List_Types.Cons({
                                        rslice: v.value0.rslice,
                                        trans: v.value0.trans,
                                        op: new ProtoVoices_Model.Hori({
                                            childl: res.value0,
                                            childm: res.value1.value0,
                                            childr: ProtoVoices_Model.detachSegment(res.value1.value1.value0)
                                        })
                                    }, new Data_List_Types.Cons(v.value1.value0, res.value1.value1.value1)));
                                };
                                return lift(new Data_Either.Left("invalid result of hori"));
                            });
                        });
                    });
                };
                throw new Error("Failed pattern match at Pruning (line 32, column 44 - line 56, column 59): " + [ v.value0.op.constructor.name ]);
            };
            throw new Error("Failed pattern match at Pruning (line 24, column 3 - line 24, column 69): " + [ v.constructor.name ]);
        };
        return bind1(evalStateT(go(red.segments))(nsteps))(function (segs$prime) {
            return pure1({
                nextSliceId: red.nextSliceId,
                nextTransId: red.nextTransId,
                start: red.start,
                segments: segs$prime
            });
        });
    };
};
var pruneModel = function (n) {
    return function (model) {
        return bind1(pruneReduction(n)(model.reduction))(function (red$prime) {
            return pure1({
                piece: model.piece,
                styles: model.styles,
                reduction: red$prime
            });
        });
    };
};
var horiEdgesRight = function (slicer) {
    return function (edgesr) {
        var v = function (v1) {
            if (Data_Boolean.otherwise) {
                return edgesr;
            };
            throw new Error("Failed pattern match at Pruning (line 114, column 1 - line 114, column 42): " + [ slicer.constructor.name, edgesr.constructor.name ]);
        };
        if (slicer.notes instanceof ProtoVoices_Model.Inner) {
            var replaceLeft = function (v1) {
                var v2 = function (v3) {
                    if (Data_Boolean.otherwise) {
                        return Data_Maybe.Nothing.value;
                    };
                    throw new Error("Failed pattern match at Pruning (line 114, column 1 - line 114, column 42): " + [ v1.constructor.name ]);
                };
                if (v1.left instanceof ProtoVoices_Model.Inner) {
                    var $145 = Data_Array.find(function (n) {
                        if (n.expl instanceof ProtoVoices_Model.HoriExpl) {
                            return n.expl.value0.id === v1.left.value0.id;
                        };
                        return false;
                    })(slicer.notes.value0);
                    if ($145 instanceof Data_Maybe.Just) {
                        return new Data_Maybe.Just({
                            left: new ProtoVoices_Model.Inner($145.value0.note),
                            right: v1.right
                        });
                    };
                    return v2(true);
                };
                return v2(true);
            };
            return {
                regular: catMaybes(map2(replaceLeft)(edgesr.regular)),
                passing: Data_Array.catMaybes(map3(replaceLeft)(edgesr.passing))
            };
        };
        return v(true);
    };
};
var horiEdgesLeft = function (edgesl) {
    return function (slicel) {
        var v = function (v1) {
            if (Data_Boolean.otherwise) {
                return edgesl;
            };
            throw new Error("Failed pattern match at Pruning (line 95, column 1 - line 95, column 41): " + [ edgesl.constructor.name, slicel.constructor.name ]);
        };
        if (slicel.notes instanceof ProtoVoices_Model.Inner) {
            var replaceRight = function (v1) {
                var v2 = function (v3) {
                    if (Data_Boolean.otherwise) {
                        return Data_Maybe.Nothing.value;
                    };
                    throw new Error("Failed pattern match at Pruning (line 95, column 1 - line 95, column 41): " + [ v1.constructor.name ]);
                };
                if (v1.right instanceof ProtoVoices_Model.Inner) {
                    var $163 = Data_Array.find(function (n) {
                        if (n.expl instanceof ProtoVoices_Model.HoriExpl) {
                            return n.expl.value0.id === v1.right.value0.id;
                        };
                        return false;
                    })(slicel.notes.value0);
                    if ($163 instanceof Data_Maybe.Just) {
                        return new Data_Maybe.Just({
                            left: v1.left,
                            right: new ProtoVoices_Model.Inner($163.value0.note)
                        });
                    };
                    return v2(true);
                };
                return v2(true);
            };
            return {
                regular: catMaybes(map2(replaceRight)(edgesl.regular)),
                passing: Data_Array.catMaybes(map3(replaceRight)(edgesl.passing))
            };
        };
        return v(true);
    };
};
var countSteps = function (red) {
    var split = function (v) {
        return function (ag) {
            return function (v1) {
                return discard2(modify_1(function (v2) {
                    return v2 + 1 | 0;
                }))(function () {
                    return pure2(map4(ProtoVoices_Folding.nothingMore)(new Data_List_Types.Cons(v1.childl, new Data_List_Types.Cons(ProtoVoices_Model.attachSegment(v1.childr)(ag.seg.rslice), Data_List_Types.Nil.value))));
                });
            };
        };
    };
    var splitRight = function (s) {
        return function (_ag1) {
            return function (ag2) {
                return split(s)(ag2);
            };
        };
    };
    var hori = function (v) {
        return function (v1) {
            return function (ag2) {
                return function (v2) {
                    return discard2(modify_1(function (v3) {
                        return v3 + 1 | 0;
                    }))(function () {
                        return pure2(map4(ProtoVoices_Folding.nothingMore)(new Data_List_Types.Cons(v2.childl, new Data_List_Types.Cons(v2.childm, new Data_List_Types.Cons(ProtoVoices_Model.attachSegment(v2.childr)(ag2.seg.rslice), Data_List_Types.Nil.value)))));
                    });
                };
            };
        };
    };
    var countingAlg = {
        init: function (v) {
            return pure2(Data_Unit.unit);
        },
        freezeLeft: function (v) {
            return function (v1) {
                return pure2(Data_Unit.unit);
            };
        },
        freezeOnly: function (v) {
            return function (v1) {
                return pure2(Data_Unit.unit);
            };
        },
        splitLeft: split,
        splitOnly: split,
        splitRight: splitRight,
        hori: hori
    };
    var agenda = map4(ProtoVoices_Folding.nothingMore)(red.segments);
    return Data_Function.flip(Control_Monad_State.execState)(0)(ProtoVoices_Folding.walkGraph(countingAlg)(red.start)(agenda));
};
export {
    pruneModel,
    pruneReduction,
    countSteps,
    horiEdgesLeft,
    horiEdgesRight
};
